import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const onChange = (attr) => async (value) => {
    resource.attr(attr, value);
  };
  return (
    <Box className={classNames(classes.root, className)}>
      <MetaControlField
        attr={'accountDisplayName'}
        resource={resource}
      />
      <MetaControlField
        attr={'shouldImportAccount'}
        resource={resource}
        onChange={onChange('shouldImportAccount')}
      />
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
